// extracted by css-extract-rspack-plugin
export default {"cls1":"TopBar-cls1_QbL","cls2":"TopBar-cls2_tQ8 TopBar-cls1_QbL"};